/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { B as Button, d as defineCustomElement$1 } from './button.js';

const CalciteButton = Button;
const defineCustomElement = defineCustomElement$1;

export { CalciteButton, defineCustomElement };

//# sourceMappingURL=calcite-button.js.map